export type ImageFocus = { x: number; y: number; zoom?: number };

function clampPct(n: number): number {
  if (!Number.isFinite(n)) return 50;
  return Math.max(0, Math.min(100, n));
}

function clampZoom(n: number): number {
  if (!Number.isFinite(n)) return 1;
  return Math.max(1, Math.min(2.5, n));
}

export function focusToObjectPosition(focus?: ImageFocus | null): string | undefined {
  if (!focus) return undefined;
  const x = clampPct(Number(focus.x));
  const y = clampPct(Number(focus.y));
  return `${x}% ${y}%`;
}

export function focusToZoom(focus?: ImageFocus | null): number {
  const z = Number((focus as any)?.zoom ?? 1);
  return clampZoom(z);
}

export function getCoverFocusFromAtmosphere(raw: any): ImageFocus | null {
  const obj = (() => {
    if (!raw) return null;
    if (typeof raw === 'object') return raw as any;
    if (typeof raw === 'string') {
      const t = raw.trim();
      if (!t) return null;
      try {
        return JSON.parse(t);
      } catch {
        return null;
      }
    }
    return null;
  })();

  const v = (obj as any)?.effects?.__cover_focus;
  if (!v || typeof v !== 'object') return null;
  const x = Number((v as any).x);
  const y = Number((v as any).y);
  const zoom = Number((v as any).zoom ?? (v as any).z ?? 1);
  if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
  return { x: clampPct(x), y: clampPct(y), zoom: clampZoom(zoom) };
}

export function withCoverFocusInAtmosphere(atmosphere: any, focus: ImageFocus | null): any {
  const base = atmosphere && typeof atmosphere === 'object' ? { ...(atmosphere as any) } : {};
  const effects = ((base as any).effects && typeof (base as any).effects === 'object') ? { ...(base as any).effects } : {};
  if (!focus) {
    // Комментарий на русском: сброс кадрирования.
    delete (effects as any).__cover_focus;
  } else {
    (effects as any).__cover_focus = {
      x: clampPct(Number(focus.x)),
      y: clampPct(Number(focus.y)),
      zoom: clampZoom(Number((focus as any)?.zoom ?? 1)),
    };
  }
  (base as any).effects = effects;
  return base;
}

